import React from "react";
import ReactDOM from "react-dom";

export default function ToolbarPortal({
  children,
}: {
  children: React.ReactNode;
}) {
  const toolbarContainer = document.getElementById(
    "toolbar-portal-container"
  ) as HTMLElement;
  if (toolbarContainer) {
    return ReactDOM.createPortal(children, toolbarContainer);
  }
  return null;
}
